import { render, staticRenderFns } from "./MasterMajorCatalog.vue?vue&type=template&id=72491c4b&scoped=true"
import script from "./MasterMajorCatalog.vue?vue&type=script&lang=js"
export * from "./MasterMajorCatalog.vue?vue&type=script&lang=js"
import style0 from "./MasterMajorCatalog.vue?vue&type=style&index=0&id=72491c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72491c4b",
  null
  
)

export default component.exports